export default {
    fund: 'Main Cashbox Account',
    name: 'Name',
    type: {
        title: 'Type',
        main: 'Main',
        sub: 'Sub',
    },
    category: 'Classification',
    'final-account': {
        title: 'Final Account',
        operations: 'Operating',
        trade: 'Trading',
        'gains-and-losses': 'Profit and losses',
        budget: 'Balance sheet',
    },

    set: 'Set',
    reset: 'Reset',
    account: 'Account',
    save: 'Save',

    'default-warehouse': 'Default warehouse',
    no: 'ID',
    notes: 'Notes',
    warehouse: 'Warehouse',
    
    'purchasing-account': 'Purchases account',
    'purchasing-refund-account': 'Purchases refund account',
    'account-trade': 'Account (trading)',
    
    'sales-account': 'Sales account',
    'sales-refund-account': 'Sales refund account',
    
    'granted-discount-account': 'Granted discount account',
    'account-gains-and-losses-or-trade': 'Account (profit and loss/trading)',
    'account-budget': 'Account (balance sheet)',

    'earned-discount-account': 'Earned discount account',

    'rotate-profit-and-loss': 'Revolving profit and loss account',
    'rotate-materials-end-of-term': 'Closing Stock',
}